import {useCallback} from 'react';
import {useInitialLocation} from './context';
import {useCompleteLocation} from './react-router';
import {useHistory} from './useHistory';
import {usePathname, useSearch} from './useLocation';

export const useIsInitialLocation = () => {
  const search = useSearch();
  const initialLocation = useInitialLocation();
  const pathname = usePathname();
  return (
    pathname === initialLocation.pathname &&
    Boolean(search) === Boolean(initialLocation.search)
  );
};

export const useIsInitialLocationCallback = () => {
  const history = useHistory();
  const initialLocation = useInitialLocation();

  return useCallback(() => {
    return (
      history.location.pathname === initialLocation.pathname &&
      Boolean(history.location.search) === Boolean(initialLocation.search)
    );
  }, [history, initialLocation]);
};

export const useIsDirectEntryCallback = () => {
  const history = useHistory();
  const location = useCompleteLocation();
  const isInitialLocationCallback = useIsInitialLocationCallback();

  return useCallback(() => {
    return (
      isInitialLocationCallback() &&
      Boolean(history.location.key) === Boolean(location.key)
    );
  }, [history.location.key, isInitialLocationCallback, location.key]);
};
